import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <div className="w-full px-4 md:px-6 text-center py-20">
          <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-error-warning-line text-3xl md:text-4xl"></i>
          </div>
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('notFound.title')}
          </h1>
          <p className="text-sm md:text-base text-foreground-500 mb-8">
            {t('notFound.description')}
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            {t('notFound.backHome')}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}